import { Grid, HStack } from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react';
import { Label } from 'uie/components';
import './styles.css';

enum SelectorType {
  HOURS = 'hours',
  MINUTES = 'minutes',
  SECONDS = 'seconds',
  TIME = 'time',
}

interface TimePickerProps {
  setTime: (value: string) => void;
}

function TimePicker(props: TimePickerProps) {
  const [selectedHour, setSelectedHour] = useState('00');
  const [selectedMinute, setSelectedMinute] = useState('00');
  const [selectedSecond, setSelectedSecond] = useState('00');
  const [selectedTime, setSelectedTime] = useState<string | undefined>(undefined);

  function generateTimeUnits(min: number, max: number): string[] {
    return Array.from({ length: max - min + 1 }, (_, i) => (min + i).toString().padStart(2, '0'));
  }

  const hours = generateTimeUnits(1, 12); // ["00", "01", ..., "11"]
  const minutes = generateTimeUnits(0, 59); // ["00", "01", ..., "59"]
  const seconds = generateTimeUnits(0, 59); // ["00", "01", ..., "59"]

  const handleClick = useCallback(
    (value: string, selctor: SelectorType) => {
      if (selctor === SelectorType.HOURS) {
        setSelectedHour(value);
        const selectedHour = `${value}:${selectedMinute}:${selectedSecond} ${selectedTime}`;
        props.setTime(selectedHour);
      } else if (selctor === SelectorType.MINUTES) {
        setSelectedMinute(value);
        const selectedMinute = `${selectedHour}:${value}:${selectedSecond} ${selectedTime}`;
        props.setTime(selectedMinute);
      } else if (selctor === SelectorType.SECONDS) {
        setSelectedSecond(value);
        const selectedSecc = `${selectedHour}:${selectedMinute}:${value} ${selectedTime}`;
        props.setTime(selectedSecc);
      } else if (selctor === SelectorType.TIME) {
        setSelectedTime(value);
        const selectedTime = `${selectedHour}:${selectedMinute}:${selectedSecond} ${value}`;
        props.setTime(selectedTime);
      }
    },
    [selectedHour, selectedMinute, selectedSecond],
  );

  const getSelectionStatus = useCallback(
    (value: string, selctor: SelectorType) => {
      if (selctor === SelectorType.HOURS) return value === selectedHour;
      else if (selctor === SelectorType.MINUTES) return value === selectedMinute;
      else if (selctor === SelectorType.SECONDS) return value === selectedSecond;
      else if (selctor === SelectorType.TIME) return value === selectedTime;
    },
    [selectedHour, selectedMinute, selectedSecond, selectedTime],
  );

  const renderTimerScroller = useCallback(
    (selctor: string[], selectorType: SelectorType) => {
      return selctor.map((iterator, index) => (
        <Grid
          style={
            getSelectionStatus(iterator, selectorType)
              ? {
                  backgroundColor: '#1B7FF1',
                  width: selectorType === SelectorType.TIME ? 32 : 28,
                  height: 25,
                  borderRadius: 3,
                  color: 'white',
                  marginBottom: '10px',
                  justifyContent: 'center',
                }
              : {
                  // color: 'black'
                  width: selectorType === SelectorType.TIME ? 32 : 28,
                  justifyContent: 'center',
                }
          }
          onClick={() => handleClick(iterator, selectorType)}
          key={index}
          px={1}
          py={1}
          cursor="pointer"
        >
          <Label style={getSelectionStatus(iterator, selectorType) ? { color: 'white' } : {}}>
            {' '}
            {iterator}
          </Label>
        </Grid>
      ));
    },
    [getSelectionStatus, selectedHour, selectedMinute, selectedSecond, selectedTime],
  );

  return (
    <HStack gap={3} padding={5}>
      <Grid flexDirection="column">
        <HStack justifyContent="center" mb={5} width={'25px'}>
          <Label>hh</Label>
        </HStack>
        <Grid
          flexDirection="column"
          overflow={'auto'}
          height={'232px'}
          width={'45px'}
          overflowX="hidden"
          className="custom-scroll"
        >
          {renderTimerScroller(hours, SelectorType.HOURS)}
        </Grid>
      </Grid>
      <Grid flexDirection="column">
        <HStack justifyContent="center" mb={5} width={'25px'}>
          <Label>mm</Label>
        </HStack>
        <Grid
          flexDirection="column"
          overflow={'auto'}
          height={'232px'}
          width={'40px'}
          overflowX="hidden"
          className="custom-scroll"
        >
          {renderTimerScroller(minutes, SelectorType.MINUTES)}
        </Grid>
      </Grid>
      <Grid flexDirection="column">
        <HStack justifyContent="center" mb={5} width={'25px'}>
          <Label>ss</Label>
        </HStack>
        <Grid
          flexDirection="column"
          overflow={'auto'}
          height={'232px'}
          width={'45px'}
          overflowX="hidden"
          className="custom-scroll"
        >
          {renderTimerScroller(seconds, SelectorType.SECONDS)}
        </Grid>
      </Grid>
      <Grid
        flexDirection="column"
        justifyContent="flex-start"
        alignItems={'start'}
        height={'100%'}
        display="flex"
      >
        <HStack justifyContent="center" mb={5} width={'45px'}>
          <Label>{'  '}</Label>
        </HStack>
        <Grid
          flexDirection="column"
          overflow={'scroll'}
          justifyContent="flex-start"
          alignItems="start"
          overflowX="hidden"
        >
          {renderTimerScroller(['AM', 'PM'], SelectorType.TIME)}
        </Grid>
      </Grid>
    </HStack>
  );
}

export default TimePicker;
